import { GOOGLE_MAPS_DOMAIN } from 'apps/web_forms/utils/constants';

export function getDirectionUrl(origin, destination, travelmode = 'driving') {
  let url;
  if (origin && destination) {
    url = `${GOOGLE_MAPS_DOMAIN}/maps/dir/?api=1&origin=${origin.lat},${origin.lng}&destination=${destination.lat},${destination.lng}&travelmode=${travelmode}`;
  }
  return url;
}
